import { PERISCOPE_PICKLIST_COPY } from '@sonar-software/sonar-ts-constants';
import { PeriscopeTablessContent } from '../../../general';
import { usePeriscopeActions } from '@hooks';
import { PeriscopeBaseComponentProps, PeriscopeBodyComponent } from '../../../types';
import { PeriscopePicklistValueSummary, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

type PicklistValueScopeProps = PeriscopeBaseComponentProps<PeriscopePicklistValueSummary>;

export const PicklistValueScope: PeriscopeBodyComponent<PicklistValueScopeProps> = ({ data, index }) => {
	const { openPeriscope } = usePeriscopeActions();
	const { parentField, parentEntity } = data;

	const handleFieldClick = useCallback(() => {
		openPeriscope({
			id: parentField.sonarObjectId,
			name: parentField.displayName,
			openedFromIndex: index,
			type: SonarObjectType.SalesforceField
		});
	}, [ index, openPeriscope, parentField.displayName, parentField.sonarObjectId ]);

	const handleEntityClick = useCallback(() => {
		openPeriscope({
			id: parentEntity.sonarObjectId,
			name: parentEntity.displayName,
			openedFromIndex: index,
			type: SonarObjectType.SalesforceEntity
		});
	}, [ index, openPeriscope, parentEntity.displayName, parentEntity.sonarObjectId ]);

	return (
		<PeriscopeTablessContent>
			{ PERISCOPE_PICKLIST_COPY.DESCRIPTION_PREFIX }
			<b
				className='clickable'
				onClick={ handleFieldClick }>
				{ parentField.displayName }
			</b>
			{ PERISCOPE_PICKLIST_COPY.DESCRIPTION_MIDDLE }
			<b
				className='clickable'
				onClick={ handleEntityClick }>
				{ parentEntity.displayName }
			</b>
			{ PERISCOPE_PICKLIST_COPY.DESCRIPTION_SUFFIX }
		</PeriscopeTablessContent>
	);
};
